import { Injectable } from '@angular/core';
import { HttpClient, } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { AuthService } from '../../../auth/_services/auth.service';
import { BehaviorSubject } from 'rxjs';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class AccountService {
  ammount$ = new BehaviorSubject(0);
  constructor(private http: HttpClient, private authService: AuthService, private toastr: ToastrService) {}  
  getAll() {  
    return this.http.get(environment.baseURL+'AccountModule/AccountList').pipe(
      map((response: any) => {
        return response;
      }),
      catchError(err => {
        if (err.status == '401' || err.status == '500') {
          this.authService.logout();
          this.toastr.error("your session has been expired please login again", 'Error!');  
        }
        return null;
      })
    );
  }
  create(resource) {   
    return this.http.post(environment.baseURL+ 'AccountModule/CreateAccount', resource)
    .pipe(
      map((response: any) => {
        return response;
      }),
      catchError(err => {
        if (err.status == '401' || err.status == '500') {
          this.authService.logout();
          this.toastr.error("your session has been expired please login again", 'Error!');  
        }
        return null;
      })
    );
  }
  RefundAmount(obj) {       
    return this.http.post(environment.baseURL +'UserPaymentInfo/Refund-UserPaymentInfo',obj).pipe(
      map((response: any) => {
        return response;
      }),
      catchError(err => {
        if (err.status == '401' || err.status == '500') {
          this.authService.logout();
          this.toastr.error("your session has been expired please login again", 'Error!');  
        }
        return null;
      })
    );
  }
  GetAccountByID(id) {   
    return this.http.get(environment.baseURL +'AccountModule/GetAccountByID?Id='+id).pipe(
      map((response: any) => {
        return response;
      }),
      catchError(err => {
        if (err.status == '401' || err.status == '500') {
          this.authService.logout();
          this.toastr.error("your session has been expired please login again", 'Error!');  
        }
        return null;
      })
    );
  }
  UpdateAccount(resource) {
    return this.http.put(environment.baseURL+'AccountModule/UpdateAccount?Id='+resource.ccountId, resource).pipe(
      map((response: any) => {
        return response;
      }),
      catchError(err => {
        if (err.status == '401' || err.status == '500') {
          this.authService.logout();
          this.toastr.error("your session has been expired please login again", 'Error!');  
        }
        return null;
      })
    );
  }
  loadAmmount(value:any) {				
		this.ammount$.next(value);
	}
}